import { history } from '@/redux/lib/configureStore.js';
import { GRAVITY_WEBSITE_HANDOFF_HISTORY_STATE_KEY } from './gravityWebsiteHandoffConstants.js';
import { readRememberedGravityWebsiteHandoffId } from './gravityWebsiteHandoffMemory.js';
import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';
import readGravityWebsiteHandoff from './readGravityWebsiteHandoff.js';

const readGravityWebsiteHandoffIdForSignup = (query = {}) => {
  const queryHandoffId = String(query.websiteHandoffId || '').trim();
  if (isGravityWebsiteHandoffId(queryHandoffId)) {
    return queryHandoffId;
  }

  const historyHandoffId = String(history.location?.state?.[GRAVITY_WEBSITE_HANDOFF_HISTORY_STATE_KEY] || '').trim();
  const rememberedHandoffId = readRememberedGravityWebsiteHandoffId();
  if (isGravityWebsiteHandoffId(historyHandoffId) && rememberedHandoffId === historyHandoffId) {
    return historyHandoffId;
  }

  const storedHandoff = readGravityWebsiteHandoff();

  return isGravityWebsiteHandoffId(historyHandoffId) && storedHandoff?.handoffId === historyHandoffId && storedHandoff.ready === false ? historyHandoffId : '';
};

export default readGravityWebsiteHandoffIdForSignup;
